var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCredit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_167_2566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.38213 13.417L5.09046 16.1253L3.68213 20.4868C3.45453 21.1632 3.45165 21.8951 3.67391 22.5733C3.89616 23.2516 4.33165 23.8398 4.91546 24.2503C5.48926 24.6741 6.18462 24.9011 6.89791 24.8975C7.6112 24.8939 8.30425 24.66 8.87379 24.2305L12.4998 21.5618L16.1269 24.2274C16.6997 24.6487 17.3913 24.8776 18.1023 24.881C18.8133 24.8845 19.5071 24.6624 20.084 24.2467C20.6608 23.831 21.091 23.2431 21.3126 22.5675C21.5343 21.8919 21.536 21.1634 21.3175 20.4868L19.9092 16.1253L23.6175 13.417C24.1896 12.9988 24.6148 12.4105 24.8325 11.7362C25.0502 11.0618 25.0492 10.3359 24.8297 9.6622C24.6102 8.98845 24.1834 8.4013 23.6103 7.98461C23.0371 7.56793 22.347 7.34302 21.6384 7.34201H17.0832L15.7009 3.03367C15.4835 2.3555 15.0564 1.7639 14.4811 1.34416C13.9057 0.924419 13.212 0.698242 12.4998 0.698242C11.7877 0.698242 11.0939 0.924419 10.5186 1.34416C9.94331 1.7639 9.51617 2.3555 9.29879 3.03367L7.9165 7.34201H3.36546C2.65686 7.34302 1.9667 7.56793 1.39356 7.98461C0.820426 8.4013 0.393627 8.98845 0.174128 9.6622C-0.0453715 10.3359 -0.046343 11.0618 0.171352 11.7362C0.389047 12.4105 0.814273 12.9988 1.38629 13.417H1.38213Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_167_2566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredit);
export default __webpack_public_path__ + "static/media/credit.35e36c0d00280c0de058e544c33b9856.svg";
export { ForwardRef as ReactComponent };